import React from "react";
import { connect } from "react-redux";

import Ranges from "./Ranges";

const RangesContainer = props => {
  return <Ranges {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(RangesContainer);



// WEBPACK FOOTER //
// src/containers/metier/referential/Ranges.container.js